import ListColumnModel from 'modules/base/model/list-column-model'

export default class ChartOfAccountsListColumnModel extends ListColumnModel {
  constructor(data) {
    super(data)

    this.displayed = data.displayed || true
    this.suppressMenu = data.suppressMenu || true

    // special cell renderer for favorite column, defined in chartOfAccounts-list
    if (this.name === 'favorite') {
      this.cellRenderer = 'favoriteCellRenderer'
    }
  }
}
